import { User } from '../models/user';
import { Roles } from './enums';

export const userRoles = {
  [Roles.ADMIN]: 'Admin',
  [Roles.SUPPORT]: 'Support'
};
/**
 * Displays the user roles
 * @param roles - The user roles
 * @returns the name of roles
 */
export function displayRoles(roles: Roles[]): any {
  if (!roles || roles.length === 0) {
    return 'Normal user';
  }

  return roles.map((role) => userRoles[role]).toString();
}
/**
 * Displays the user status
 * @param enabled - Boolean to know if the user is enabled or not
 * @param user - User to display the status
 * @returns Pending or Enabled
 */
export function displayStatus(enabled: boolean, user: User): string {
  let status = 'Pending';
  if (enabled) {
    status = 'Enabled';
  }

  if(user.deleted) {
    status = 'Deleted';
  }

  return status;
}
